import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ratio ratio-16x9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("iframe", {
  title: "Video YouTube",
  id: "ytplayer",
  type: "text/html",
  src: "https://www.youtube-nocookie.com/embed/x4e7IjviblA?rel=0&autoplay=1&mute=1",
  frameborder: "0",
  allowfullscreen: ""
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { useWidget } from "@/composables/useWidget";
import { onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const router = useRouter();
const { isTryAndBuyMode } = useWidget();

onMounted(() => {
    console.log(window.location);
    if (isTryAndBuyMode.value) {
        console.log(window.location);
        const tenantUrl = window.location.hostname;
        const search = window.location.search;
        if (tenantUrl.includes("re-aprica-bergamo-frontend")) {
            router.replace({
                name: "tenant",
                query: { tenantName: "aprica", comune: "bergamo" }
            });
        }
        if (tenantUrl.includes("re-aprica-brescia-frontend")) {
            router.replace({
                name: "tenant",
                query: { tenantName: "aprica", comune: "brescia" }
            });
        }
        if (tenantUrl.includes("re-a2aci-frontend")) {
            router.replace({ name: "tenant", query: { tenantName: "aci" } });
        }
        if (tenantUrl.includes("re-a2acs-frontend")) {
            router.replace({ name: "tenant", query: { tenantName: "acs" } });
        }
        if (tenantUrl.includes("re-asvt-frontend")) {
            router.replace({ name: "tenant", query: { tenantName: "asvt" } });
        }
        if (tenantUrl.includes("cesf")) {
            router.replace({ name: "tenant", query: { tenantName: "training" } });
        }
        if (tenantUrl.includes("agid.c2i.it")) {
            router.replace({ name: "tenant", query: { tenantName: "training" } });
        }
        if (tenantUrl.includes("comune-agid.dp365.it") || tenantUrl.includes("cortona-agid.dp365.it")) {
            if (search.includes("service=")) {
                var url = search.split("service=")[1];
                let servizioId = url.split("&")[0];
                router.replace({ name: "tenant", query: { tenantName: "training", service: servizioId } });
            } else {
                router.replace({ name: "tenant", query: { tenantName: "training" } });
            }
        }
    } else {
        const paramsIndex = window.location.href.indexOf("?");
        var queryParamsString = "";
        if (paramsIndex >= 0) {
            queryParamsString = window.location.href.substring(paramsIndex + 1, window.location.href.length);
        }

        const searchParams = new URLSearchParams(queryParamsString);

        // const params = window.location.search;
        // const searchParams = new URLSearchParams(params);

        var queryObject = {} as any;
        if (searchParams.has("tenant")) {
            queryObject["tenant"] = searchParams.get("tenant");
        }
        if (searchParams.has("tenantName")) {
            queryObject["tenantName"] = searchParams.get("tenantName");
        }
        if (searchParams.has("comune")) {
            queryObject["comune"] = searchParams.get("comune");
        }
        if (searchParams.has("location")) {
            queryObject["location"] = searchParams.get("location");
        }
        if (searchParams.has("roomtype")) {
            queryObject["roomtype"] = searchParams.get("roomtype");
        }
        if (searchParams.has("service")) {
            queryObject["service"] = searchParams.get("service");
        }
        if (searchParams.has("servicecms")) {
            queryObject["servicecms"] = searchParams.get("servicecms");
        }
        if (searchParams.has("skipuserchoice")) {
            queryObject["skipuserchoice"] = searchParams.get("skipuserchoice");
        }
        if (searchParams.has("lnm")) {
            queryObject["lnm"] = searchParams.get("lnm");
        }
        if (searchParams.has("cser")) {
            queryObject["cser"] = searchParams.get("cser");
        }

        if (searchParams.has("action")) {
            let action = searchParams.get("action");
            if (action == "editbook") {
                queryObject["fturl"] = "editbook";
            }
        }

        router.push({ name: "tenant", query: queryObject });
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})